import React from 'react';

export class CloseRow extends React.Component {

  handleOnCloseClicked = ($event) => {
    const { handleClose } = this.props;
    $event.preventDefault();
    handleClose();
  }

  render () {
    return (
      <div className="row no-gutters deet-close-row">
        <div className="col" />
        <i className="material-icons clickable" onClick={ this.handleOnCloseClicked }>close</i>
      </div>
    );
  }
}